export function Badge({ children, color = "gray" }) {
  const colors = {
    green: "bg-emerald-500/15 text-emerald-400 border-emerald-500/30",
    red: "bg-red-500/15 text-red-400 border-red-500/30",
    amber: "bg-amber-500/15 text-amber-400 border-amber-500/30",
    blue: "bg-sky-500/15 text-sky-400 border-sky-500/30",
    gray: "bg-white/10 text-white/60 border-white/20",
    purple: "bg-violet-500/15 text-violet-400 border-violet-500/30",
  };
  return <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium border ${colors[color]}`}>{children}</span>;
}

export function StatusBadge({ status }) {
  const map = { Active: "green", Planning: "blue", "On Hold": "amber", Closed: "gray", Open: "blue", "Partially Received": "amber", Received: "green", Cancelled: "red", Unpaid: "red", "Partially Paid": "amber", Paid: "green" };
  return <Badge color={map[status] || "gray"}>{status}</Badge>;
}
